var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8c7c5b2d8f125ae69b93f2a986894cab2b2d532e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["widget@swipelux-mh"]={id:"8c7c5b2d8f125ae69b93f2a986894cab2b2d532e"};
      